import { createDependency, getActiveRule } from './rule';
import { cloneDeclaration, getPathFromRoot } from './utils';
import { SPECIFICITY_TOKEN } from '../../../stylesheets';
function mergeDeclarationValues(values, { calc = false, delimiter = ' ', defaultValue = '', reverseOrder = false }) {
    let result = '';
    const lastIndex = values.length - 1;
    for(let i = 0; i < values.length; i++){
        const index = reverseOrder ? lastIndex - i : i;
        const value = values[index];
        result = result ? result + delimiter + value : value;
    }
    if (calc && values.length > 1) {
        return `calc(${result})`;
    }
    return result || defaultValue;
}
function toCompositePartProperty(property) {
    return `--composite-${property}`;
}
export function createCompositeProperty(compositeProperty, { merge = {}, order, fallback = '' }) {
    const parts = order.map((property)=>toCompositePartProperty(property));
    const compositeValue = mergeDeclarationValues(parts.map((part)=>`var(${part})`), merge);
    let compositeDecls = `${compositeProperty}: ${compositeValue};`;
    parts.forEach((part)=>{
        let value = typeof fallback === 'string' ? fallback : fallback(part);
        if (value === ' ') {
            // Stylis removes properties with a space value even though they’re valid.
            // Use an undefined variable that will fall back to the empty space.
            value = 'var(--unset, )';
        }
        compositeDecls += `\n${part}: ${value};`;
    });
    return function(transform) {
        return function(element) {
            if (element.children === compositeValue) {
                return;
            }
            const property = element.props;
            let contents = element.children;
            if (transform) {
                contents = transform(contents);
            }
            const activeRuleSelector = `${SPECIFICITY_TOKEN} .${getActiveRule().className}`;
            const path = getPathFromRoot(element).map((s)=>`${s.replace(activeRuleSelector, '&')} {\n`);
            const open = path.join('');
            const close = '\n}'.repeat(path.length);
            createDependency(`composite-${compositeProperty}-${open}`, (deprecatedCss)=>deprecatedCss(`${open}${compositeDecls}${close}`))();
            const customProperty = toCompositePartProperty(property);
            return [
                cloneDeclaration(element, customProperty, contents)
            ];
        };
    };
}

//# sourceMappingURL=composite.js.map